import { render } from "./BaseTodoList.vue?vue&type=template&id=45de45d2"
import script from "./BaseTodoList.vue?vue&type=script&lang=js"
export * from "./BaseTodoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__